import React from 'react';
import { TextField, InputAdornment, IconButton, Typography, Stack } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

const ChatSearchBar = ({ value, onChange, onClear, filteredCount, totalCount, isFiltering }) => {
  return (
    <Stack
      direction='row'
      spacing={1}
      sx={{
        alignItems: 'center',
        pt: 1
      }}>
      <TextField
        size='small'
        variant='outlined'
        fullWidth
        placeholder='Search messages...'
        value={value}
        onChange={onChange}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon fontSize='small' sx={{ color: '#999' }} />
              </InputAdornment>
            ),
            endAdornment: value ? (
              <InputAdornment position='end'>
                <IconButton size='small' onClick={onClear} edge='end'>
                  <ClearIcon fontSize='small' />
                </IconButton>
              </InputAdornment>
            ) : null
          }
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            fontSize: '0.875rem',
            '& fieldset': {
              borderColor: '#d7dfe3'
            }
          }
        }}
      />
      {isFiltering && (
        <Typography variant='caption' sx={{ color: '#666', whiteSpace: 'nowrap', flexShrink: 0 }}>
          {filteredCount} of {totalCount}
        </Typography>
      )}
    </Stack>
  );
};

export default ChatSearchBar;
